<template>
  <div class="filter">
    <div class="innerItem filterInput">
      <p class="innerTitle toCapitalize f_medium" :placeholder="locale.search_placeholder">{{locale.search}}</p>
      <input type="text" class="input" :placeholder="locale.search_placeholder" v-model="categoryFilter.word">
    </div>
    <!-- category -->
    <div class="innerItem filterCategory">
      <p class="innerTitle toCapitalize f_medium">
        {{locale.category}}
        <button type="button" class="btn btnWhite sizeXs" @click="categoryLayer = true">{{locale.setting}}</button>
      </p>
      <p v-if="!category.length" class="noData">{{locale.category_nodata}}</p>
      <div v-if="categoryLayer" class="layer categorySetLayer">
        <div class="inner">
          <button type="button" class="btnClose" @click="categoryLayer = false"><span class="blind">close</span></button>
          <h2 class="layerTitle">{{locale.category}}</h2>
          <p v-if="category.filter(x => x.data.id !== '').length" class="sysMessage">{{locale.product_message_add_category}}</p>
          <p v-else class="noData">{{locale.category_nodata}}</p>
          <Tree class="treeList"
            :options="treeOptions"
            @node:editing:stop="endEditLabel"
            ref="category">
            <div slot-scope="{ node }" class="item"
              :class="{unCategorized: node.data.id === '', hasThumb: node.data.image && node.data.image.length}">
              <!-- category icon
              <div v-if="node.data.id !== ''" :class="{menuIcon: true, active: typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''}">
                <label :for="node.data.id" class="upload" @click.stop><input type="file" :id="node.data.id" @change="uploadIcon(node, $event)">
                  M
                </label>
                <img v-if="typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''" :src="node.data.icon" alt="" />
                <button v-if="typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''" type="button" class="btnDel" @click="delIcon(node)"><span class="blind">remove</span></button>
              </div>
              //category icon -->
              <!-- category icon tablet
              <div v-if="node.data.id !== ''" :class="{menuIcon: true, active: typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''}">
                <label :for="`${node.data.id}_2`" class="upload" @click.stop><input type="file" :id="`${node.data.id}_2`" @change="uploadIcon(node, $event, 'icon2')">
                  T
                </label>
                <img v-if="typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''" :src="node.data.icon2" alt="" />
                <button v-if="typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''" type="button" class="btnDel" @click="delIcon(node, 'icon2')"><span class="blind">remove</span></button>
              </div>
              //category icon tablet -->
              <div v-if="node.data.id !== ''" class="listLabel">
                <input v-model="node.data.label[lang.default]" type="text" class="input">
                <div v-if="!node.isEditing" class="input" @click.stop="editNode(node)">
                  <span v-if="node.data.label[lang.default] && node.data.label[lang.default].trim() === ''" class="placeholder">menu</span>
                  {{node.data.label[lang.default]}}
                </div>
              </div>
              <div v-if="node.data.id !== ''" class="edit">
                <div class="editGroup">
                  <button type="button" title="edit name" @click.stop="editNode(node)"><img src="~@/assets/img/ico_pencil.svg" alt=""></button>
                  <button type="button" class="translation" :title="locale.language_specific_set" @click.stop="onLangValueOpen(node.data)">
                    <span class="blind">{{locale.language_specific_set}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                  </button>
                  <!-- category image
                  <button type="button" class="btnSetImage" @click="setSlider(node.data)">
                    <i v-if="node.data.image && node.data.image.length">X{{node.data.image.length}}</i>
                    <span class="blind">image</span>
                  </button>
                  //category image -->
                  <button v-if="node.depth <= 1" type="button" title="add" @click.stop="addChildNode(node)"><img src="~@/assets/img/ico_plus.svg" alt=""></button>
                  <button type="button" title="remove" @click.stop="removeNode(node)"><img src="~@/assets/img/ico_minus.svg" alt=""></button>
                </div>
              </div>
            </div>
          </Tree>
          <button type="button" class="btn btnFull btnWhite" @click="addCategory">{{locale.category_add}}</button>
        </div>
      </div>
      <ul v-if="category.length" class="categoryFilterList">
        <li v-for="cate in category"
          :key="cate.data.id"
          :class="{uncategorized: cate.data.id === ''}">
          <div class="checkbox">
            <input
              type="checkbox"
              :id="`filter_${cate.data.id}`"
              :value="cate.data.id"
              v-model="categoryFilter.list"
              @change="checkedCategory($event, cate.data.id)">
            <label :for="`filter_${cate.data.id}`">{{cate.data.id === '' ? 'Uncategorized' : cate.data.label[lang.default]}}</label>
          </div>
          <ul v-if="cate.children" class="children">
            <li v-for="depth1 in cate.children"
              :key="depth1.data.id">
              <div class="checkbox">
                <input type="checkbox" :id="`filter_${depth1.data.id}`" :value="depth1.data.id" v-model="categoryFilter.list" @change="checkedCategory($event, depth1.data.id)">
                <label :for="`filter_${depth1.data.id}`">{{depth1.data.label[lang.default]}}</label>
              </div>
              <ul v-if="depth1.children" class="children">
                <li v-for="depth2 in depth1.children"
                  :key="depth2.data.id">
                  <div class="checkbox">
                    <input type="checkbox" :id="`filter_${depth2.data.id}`" :value="depth2.data.id" v-model="categoryFilter.list" @change="checkedCategory($event, depth2.data.id)">
                    <label :for="`filter_${depth2.data.id}`">{{depth2.data.label[lang.default]}}</label>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <!-- <li class="uncategorized">
          <div class="checkbox">
            <input
              type="checkbox"
              id="filter_uncategorized"
              value=""
              v-model="categoryFilter.list"
              @change="checkedCategory($event, '')">
            <label for="filter_uncategorized">uncategorized</label>
          </div>
        </li> -->
      </ul>
    </div>
    <!-- //category -->
    <!-- manage -->
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.management_product}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_manage_on"
            v-model="listView.manageOn"
            :disabled="listView.manageOn && !listView.manageOff" />
          <label for="view_manage_on">{{locale.management_product}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_manage_off"
            v-model="listView.manageOff"
            :disabled="!listView.manageOn && listView.manageOff" />
          <label for="view_manage_off">{{locale.individual_product}}</label>
        </span>
      </div>
    </div>
    <!-- //manage -->
    <!-- service -->
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.amenity_state_service}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_on"
            v-model="listView.serviceOn"
            :disabled="listView.serviceOn && !listView.serviceOff" />
          <label for="view_service_on">{{locale.amenity_state_service_on}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_off"
            v-model="listView.serviceOff"
            :disabled="!listView.serviceOn && listView.serviceOff" />
          <label for="view_service_off">{{locale.amenity_state_service_off}}</label>
        </span>
      </div>
    </div>
    <!-- //service -->
    <!-- disabled -->
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.amenity_state_request}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_enabled"
            v-model="listView.enabled"
            :disabled="listView.enabled && !listView.disabled" />
          <label for="view_service_enabled">{{locale.amenity_state_request_on}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_disabled"
            v-model="listView.disabled"
            :disabled="!listView.enabled && listView.disabled" />
          <label for="view_service_disabled">{{locale.amenity_state_request_off}}</label>
        </span>
      </div>
    </div>
    <!-- //disabled -->
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :textarea="false"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 카테고리 슬라이더 세팅
    <div class="layer setCategoryImage"
      v-if="settingCategory">
      <div class="inner">
        <button type="button" class="btnClose" @click="closeSlider"><span class="blind">close</span></button>
        <h2 class="layerTitle">{{settingCategory.label[lang.default]}} {{locale.category_image_settings}}</h2>
        <draggable class="categoryImage"
          tag="div"
          v-if="categoryImage && categoryImage.length"
          v-model="categoryImage"
          v-bind="dragOptions"
          @change="updateCategoryImage"
          handle=".handleMove">
          <transition-group type="transition"
            class="images"
            tag="div">
            <div class="thumb"
              v-for="(img, index) in categoryImage"
              :key="index">
              <img :src="img" alt="">
              <label :for="`upload_category_image_${index}`" class="changeImage">
                <input type="file"
                  :id="`upload_category_image_${index}`"
                  @change="uploadImage($event, index)">
              </label>
              <button type="button" class="handleMove"></button>
              <button type="button" class="deleteImage" @click="deleteImage(index)"></button>
            </div>
          </transition-group>
        </draggable>
        <p v-else class="noData">{{locale.category_image_nodata}}</p>
        <div v-if="categoryImage.length >= 4" class="maxMessage"><p>{{locale.category_image_max}}</p></div>
        <label for="upload_category_image"
          class="uploadCategoryImage"
          :class="{disabled: categoryImage.length >= 4 }">
          <input type="file"
            id="upload_category_image"
            :disabled="categoryImage.length >= 4"
            @change="uploadImage($event)">
          +
        </label>
      </div>
    </div>
    카테고리 슬라이더 세팅 -->
  </div>
</template>

<script>
import Store from '@/stores'
import UNIQUE from '@/common/unique.js'
import LANG from '@/common/lang'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'
import LangValue from '@/components/Util/LangValue.vue'
import draggable from 'vuedraggable'
import LiquorTree from 'liquor-tree'

export default {
  name: 'ProductItemFilter',
  props: [
    'locale',
    'lang',
    // 'category',
    'itemByCategory'
  ],
  components: {
    LangValue,
    draggable,
    Tree: LiquorTree
  },
  computed: {
    category () {
      return this.$store.getters['product/getCategory']
    },
    flattenCategory () {
      return this.$store.getters['product/getFlattenCategory'](true)
    },
    categoryFilter: {
      get () {
        return this.$store.getters['product/getFilter']
      },
      set (val) {
        const data = {
          word: val.word.trim().toLowerCase(), // 검색어는 대소문자, 공백 무시
          list: val.list
        }
        this.$store.commit('product/setFilter', data)
      }
    }
  },
  created () {
    this.setListView()
  },
  data () {
    return {
      word: '',
      /**
       * 리스트 보기 옵션
       * 서비스중: serviceOn
       * 비서비스: serviceOff
       * 일시중지: disabled
       */
      listView: {
        serviceOn: true,
        serviceOff: false,
        manageOn: true,
        manageOff: true,
        enabled: true,
        disabled: true
      },
      langValueLayer: false,
      langValue: {},
      langTarget: '',
      setLinkLayer: false,
      categoryLayer: false,
      settingCategory: null,
      categoryImage: [],
      defaultCategory: {
        text: ' ',
        isEditing: false,
        state: {
          expanded: true
        },
        data: {
          id: '',
          label: Store.getters['setting/getLangValues'](),
          image: [],
          icon: '',
          icon2: ''
        }
      },
      treeOptions: {
        store: {
          store: Store,
          getter: () => {
            return Store.getters['product/getCategory']
          },
          dispatcher (tree) {
            Store.commit('product/updateCategory', tree)
          }
        },
        parentSelect: true,
        dnd: true,
        indeterminate: true,
        autoCheckChildren: false,
        propertyNames: {
          data: 'data'
        }
      },
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    setListView () {
      this.$store.commit('product/listView', this.listView)
    },
    setSlider (item) {
      this.settingCategory = item
      this.categoryImage = item.image || []
    },
    closeSlider () {
      this.settingCategory = null
      this.categoryImage = []
    },
    checkedCategory (e, id) {
      const isChecked = e.target.checked
      // const isParent = this.category.find(x => x.data.id === id) && this.category.find(x => x.data.id === id).children
      const cate = this.flattenCategory.find(x => x.id === id)
      const findChildren = (cate && cate.childrenIds) || []
      const findChild = (cate && cate.childrenId) || []
      const findParent = (cate && cate.parentIds) || []
      const ids = findChildren.concat(findChild.concat(findParent))
      const categories = this.categoryFilter.list
      const list = isChecked ? this._.union(categories.concat(ids)) : categories.filter(x => !ids.includes(x))
      this.$store.commit('product/setFilter', { list: list })
    },
    addCategory () {
      const id = UNIQUE.fileid()
      const newCategory = this._.cloneDeep(this.defaultCategory)
      const list = this.category.concat([newCategory])
      newCategory.data.id = id
      this.$store.commit('product/updateCategory', list)
      this.$store.commit('product/setFilter', { list: this.categoryFilter.list.concat(id) })
    },
    updateCategoryImage () {
      const id = this.settingCategory.id
      const categoryImage = this.categoryImage
      const list = this.category.map(x => {
        return {
          ...x,
          data: {
            ...x.data,
            image: x.data.id === id ? categoryImage : x.data.image || []
          },
          ...x.children && {
            children: x.children.map(c => {
              return {
                ...c,
                data: {
                  ...c.data,
                  image: c.data.id === id ? categoryImage : c.data.image || []
                },
                ...c.children && {
                  children: c.children.map(t => {
                    return {
                      ...t,
                      data: {
                        ...t.data,
                        image: t.data.id === id ? categoryImage : t.data.image || []
                      }
                    }
                  })
                }
              }
            })
          }
        }
      })
      this.$store.commit('product/updateCategory', list)
    },
    editNode (node) {
      node.isEditing = true
    },
    endEditLabel (node) {
      const lang = this.lang.default
      node.data.label[lang] = node.data.text
      node.isEditing = false
    },
    removeNode (node) {
      if (window.confirm(this.locale.confirm_delete_category)) {
        node.remove()
      }
    },
    addChildNode (node) {
      if (node.enabled()) {
        const id = UNIQUE.fileid()
        const newCategory = this._.cloneDeep(this.defaultCategory)
        newCategory.data.id = id
        node.append(newCategory)
        node.state.expanded = true
        this.$store.commit('product/updateCategory', this.$refs.category.model)
        this.$store.commit('product/setFilter', { list: this.categoryFilter.list.concat(id) })
      }
    },
    onLangValueOpen (data) {
      this.langTarget = data.id
      this.langValueLayer = true
      this.langValue = data.label
      // this.setDefaultVal(target)
    },
    uploadIcon (node, e, icon2) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          if (icon2) {
            node.data.icon2 = res.source
          } else {
            node.data.icon = res.source
          }
          e.target.value = ''
          node.state.expanded = true
          this.$store.commit('product/updateCategory', this.$refs.category.model)
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delIcon (node, icon2) {
      if (window.confirm(this.locale.confirm_delete_icon)) {
        if (icon2) {
          node.data.icon2 = ''
        } else {
          node.data.icon = ''
        }
        node.state.expanded = true
        this.$store.commit('product/updateCategory', this.$refs.category.model)
      }
    },
    onLangValueClose () {
      const target = this.langTarget
      const label = this.langValue
      const item = getItem(this.category)
      function getItem (arr, id) {
        if (arr.find(x => x.data.id === id)) {
          return arr.find(x => x.data.id === id)
        } else if (arr.children && arr.children.length) {
          getItem(arr.children)
        }
      }
      if (item) {
        const list = this.category.map(x => {
          if (x.data.id === target) {
            return {
              ...x,
              data: {
                ...x.data,
                label: label
              }
            }
          } else if (x.children && x.children.length) {
            return {
              ...x,
              children: x.children.map(c => {
                if (c.data.id === target) {
                  return {
                    ...c,
                    data: {
                      ...c.data,
                      label: label,
                      ...(c.children && c.children.length) && {
                        children: c.children.map(d => {
                          if (d.data.id === target) {
                            return {
                              ...d,
                              data: {
                                ...d.data,
                                label: label
                              }
                            }
                          }
                        })
                      }
                    }
                  }
                }
              })
            }
          }
        })
        this.$store.commit('product/updateCategory', list)
      }
      this.langValueLayer = false
      this.langValue = {}
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.category.find(x => x.id === target).label, this.category.find(x => x.id === target).label[defaultLang])
      this.category.find(x => x.id === target).label = fillLangs
    },
    uploadImage (e, index) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          if (typeof (index) !== 'undefined') {
            this.categoryImage[index] = res.source
          } else {
            this.categoryImage.push(res.source)
          }
          e.target.value = ''
          this.updateCategoryImage()
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (index) {
      if (window.confirm(this.locale.confirm_delete_image)) {
        this.categoryImage = this.categoryImage.filter((x, i) => i !== index)
        this.updateCategoryImage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flexBox {
  margin-left: 0;
  margin-right: 0;
  .flexInner {
    padding-left: 0;
    padding-right: 0;
  }
}
.filterCategory {
  .item {
    position: relative;
    margin-bottom: 15px;
    padding: 0.8em 80px 0.8em 0.5em;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &.unCategorize {
      color: $color-grey;
      background-color: rgba($color-lgrey2, 0.2);
      .categoryInner {
        padding: 0.6em 0;
      }
    }
  }
  .categoryInner {
    display: flex;
    align-items: center;
    .checkbox {
      margin-right: 5px;
    }
    .translation {
      flex: 1;
    }
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    padding: 8px;
    font-size: 0;
    img {
      width: 14px;
    }
  }
  .btnSetImage {
    position: relative;
    opacity: 0.5;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_slider.png') 50% 50% / contain no-repeat;
      opacity: 0.5;
    }
    i {
      position: absolute;
      bottom: 2px;
      right: 4px;
      font-size: 11px;
      color: $color-dark;
      line-height: 1;
      background-color: rgba($color-white, 0.75);
    }
  }
  .hasThumb .btnSetImage {
    opacity: 1;
  }
}
.btnAddCategory {
  color: $color-dark;
  border: none;
  background: none;
}
.setCategoryImage {
  .inner {
    max-width: 1020px;
  }
  .noData {
    margin-top: 90px;
    margin-bottom: 90px;
    font-size: 1.2em;
    text-align: center;
  }
  .images {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0 0;
  }
  .thumb {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 220px;
    flex-basis: 220px;
    height: 160px;
    margin: 0 10px;
    border: 1px solid $color-lgrey;
    background-color: $color-white;
    img {
      max-height: 100%;
    }
  }
  .handleMove {
    position: absolute;
    bottom: 100%;
    right: 30px;
    width: 30px;
    height: 30px;
    cursor: move;
    background: $color-dark url('~@/assets/img/ico_move.svg') 50% 50% / 50% no-repeat;
  }
  .deleteImage {
    position: absolute;
    bottom: 100%;
    right: 0;
    width: 30px;
    height: 30px;
    background: $color-red url('~@/assets/img/ico_remove.svg') 50% 50% / 50% no-repeat;
  }
  .changeImage {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    &:before {
      content: "";
      display: block;
      width: 60px;
      height: 60px;
      border: 1px solid $color-lgrey;
      border-radius: 100%;
      overflow:hidden;
      background: $color-white url('~@/assets/img/ico_upload_image.png') 50% 50% / 40px no-repeat;
      opacity: 0.5;
    }
  }
  .thumb:hover .changeImage {
    display: block;
  }
}
.uploadCategoryImage {
  display: block;
  position: relative;
  width: 120px;
  height: 60px;
  margin: 15px auto 0;
  text-align: center;
  font-size: 2.8em;
  line-height: 54px;
  color: $color-grey;
  border: 1px solid $color-lgrey;
  border-radius: 4px;
  background-color: $color-white;
  cursor: pointer;
  &.disabled {
    background-color: $color-lgrey2;
    cursor: not-allowed;
    opacity: 0.5;
  }
}
.maxMessage {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  p {
    position: relative;
    padding: 8px 15px;
    border-radius: 50px;
    color: $color-white;
    background-color: $color-dark;
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      background-color: $color-dark;
      transform: rotate(45deg);
    }
  }
}
.categorySetLayer {
  .noData {
    margin-bottom: 30px;
    text-align: center;
    font-size: 1.2em;
  }
}
.tree {
  overflow: visible;
}
.categoryFilterList {
  .checkbox {
    display: block;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
  }
  li + li {
    margin-top: 10px;
  }
  .children {
    margin-left: 20px;
    li {
      margin-top: 3px;
    }
  }
  .uncategorized {
    color: $color-grey;
    .checkbox {
      background-color: $bg-default;
    }
  }
}
</style>
